import { render } from "./Robot-Check-Modal.vue?vue&type=template&id=58cb8112"
import script from "./Robot-Check-Modal.vue?vue&type=script&lang=js"
export * from "./Robot-Check-Modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__